/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import PlaybookTemplatesQuery$parameters from '@jira/playbooks__list-screen/src/__generated__/PlaybookTemplatesQuery$parameters.ts';
import type { PlaybookTemplatesQuery } from '@jira/playbooks__list-screen/src/__generated__/PlaybookTemplatesQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type Queries = { PlaybookTemplatesQuery: PlaybookTemplatesQuery };

type ExtraProps = {
	projectKey: string | null | undefined;
};

type PlaybookTemplatesEntryPointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

const playbookTemplatesEntryPoint: EntryPoint<
	PlaybookTemplatesEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PlaybookTemplatesEntryPointComponent>(
		/* webpackChunkName: "async-playbook-templates" */ './index.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey } = context.match.params;
		const { name = '' } = context.query;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			queries: {
				PlaybookTemplatesQuery: {
					parameters: PlaybookTemplatesQuery$parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
						filters: name ? { name } : null,
					},
				},
			},
			extraProps: {
				projectKey: context.match.params.projectKey,
			},
		};
	},
});

export default playbookTemplatesEntryPoint;
